import React, { Component } from "react";
import AppFieldError from "../form/app_field_error/app_field_error";
import { Button } from "reactstrap";

class AppSelectButton extends Component {
    constructor(props) {
        super(props);
    }

    handleNegativePress = () => {
        this.props.handleNegativePress()
    }

    handlePositivePress = () => {
        this.props.handlePositivePress()
    }

    getTitle = () => {
        return this.props.title
    }

    getDisabled = () => {
        return this.props.disabled
    }

    getCurrentValue = () => {
        return this.props.value
    }

    getNegativeButtonText = () => {
        return this.props.negativeButtonText || 'No';
    }

    getPositiveButtonText = () => {
        return this.props.positiveButtonText || 'Yes';
    }

    getErrorIndicator = () => {
        return this.props.error;
    }

    getErrorMessage = () => {
        return this.props.errorMessage;
    }

    render() {
        return (
            <div className="mt-1">
                <span className="input_title">{this.getTitle()}</span>
                <div className="mt-2">
                    <Button
                        className="adjust_btn_hover"
                        type="text"
                        style={{
                            width: '50%',
                            height: '48px',
                            borderRadius: 0,
                            boxShadow: 'none',
                            borderColor: this.getCurrentValue() == 1 || this.getCurrentValue() == this.getPositiveButtonText() ? '#EE7623' : '#D9D9D9',
                            color: this.getCurrentValue() == 1 || this.getCurrentValue() == this.getPositiveButtonText() ? 'white' : 'black',
                            backgroundColor: this.getCurrentValue() == 1 || this.getCurrentValue() == this.getPositiveButtonText() ? '#EE7623' : '#FFFFFF'
                        }}
                        disabled={this.getDisabled() || false}
                        onClick={() => this.handlePositivePress()}
                    >
                        {this.getPositiveButtonText()}
                    </Button>
                    <Button
                        style={{
                            width: '50%',
                            height: '48px',
                            borderRadius: 0,
                            boxShadow: 'none',
                            borderColor: this.getCurrentValue() == 0 || this.getCurrentValue() == this.getNegativeButtonText() ? '#EE7623' : '#D9D9D9',
                            color: this.getCurrentValue() == 0 || this.getCurrentValue() == this.getNegativeButtonText() ? '#FFFFFF' : '#000000',
                            backgroundColor: this.getCurrentValue() == 0 || this.getCurrentValue() == this.getNegativeButtonText() ? '#EE7623' : '#FFFFFF'
                        }}
                        disabled={this.getDisabled() || false}
                        onClick={() => this.handleNegativePress()}
                    >
                        {this.getNegativeButtonText()}
                    </Button>
                </div>
                {
                    this.getErrorIndicator() &&
                    <AppFieldError text={this.getErrorMessage()} />
                }
            </div>
        );
    }
}

export default AppSelectButton;
